var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('LogoLoading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_c('Hero',{staticClass:"mb-5",attrs:{"heros":_vm.heros}}),_c('About',{staticClass:"my-5",attrs:{"homeImage":_vm.homeImage}}),_c('OliveOil',{staticClass:"my-5"}),_c('Slogan',{staticClass:"my-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }